import RemoveRepository from "@domain/repositories/RemoveRepository";
import UseCase from "@domain/UseCase";
import { ImportHistory } from "@domain/models/ImportHistory";
import { RemoveHistoryClient } from "@domain/models/RemoveHistoryClient";

type Input = ImportHistory["id"];

type Output = Promise<RemoveHistoryClient[]>;

export class GetRemoveHistoryClientsUseCase implements UseCase<Input, Output> {
  constructor(private readonly removeRepository: RemoveRepository) {}

  execute(removeHistoryId: Input) {
    return this.removeRepository.getRemoveHistoryClients(removeHistoryId);
  }
}
